import { Controller } from "stimulus";
import "bootstrap-select";

export default class extends Controller {
  connect() {
    this.teardown = this.teardown.bind(this);
    // Turbolinks snapshots the page before disconnect runs, so unwrap the select first
    document.addEventListener("turbolinks:before-cache", this.teardown);
    $(this.element).selectpicker({
      liveSearch: true,
      iconBase: "",
    });
  }

  // No teardown here: bootstrap-select moves the select into its wrapper, which disconnects
  // and reconnects this controller
  disconnect() {
    document.removeEventListener("turbolinks:before-cache", this.teardown);
  }

  teardown() {
    $(this.element).selectpicker("destroy");
  }
}
